// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2PxpD","calendarButtons":"ClockData_calendarButtons__5S7dv"};